import { PlayCircle, FileText, Users, MonitorPlay, Upload, ClipboardCheck } from 'lucide-react';
import type { LessonProgress } from '@/types';

// Iconos, etiquetas y conjuntos de tipos de lección. Extraído por ENG-LOC-01.
export const LESSON_ICONS: Record<LessonProgress['type'], typeof PlayCircle> = {
  content: FileText,
  document_reading: FileText,
  video: PlayCircle,
  presentation: MonitorPlay,
  evidence_upload: Upload,
  practical_record: ClipboardCheck,
  practical_observation: ClipboardCheck,
  in_person: Users,
};

export const LESSON_TYPE_LABELS: Record<LessonProgress['type'], string> = {
  content: 'Contenido',
  document_reading: 'Lectura de documento',
  video: 'Video',
  presentation: 'Presentación',
  evidence_upload: 'Subir evidencia',
  practical_record: 'Registro práctico',
  practical_observation: 'Observación práctica',
  in_person: 'Presencial',
};

export const VIEWABLE_TYPES = new Set<LessonProgress['type']>([
  'video',
  'presentation',
  'document_reading',
  'content',
]);

export const VIEW_LABELS: Partial<Record<LessonProgress['type'], string>> = {
  document_reading: 'Leer',
};

/** Lesson types that require explicit reading confirmation checkbox. */
export const READING_TYPES = new Set<LessonProgress['type']>([
  'content',
  'document_reading',
  'presentation',
]);
